import ModelType from './ModelType';

export default class ModelCollectionType extends ModelType {
    /* ... */
}